{
  "service-selection-dialog": {
    "buttons": {
      "save": "Économiser"
    },
    "text": {
      "service-selection": "Sélection des services"
    }
  },
  "service-selection-form": {
    "buttons": {
      "add-more": "Ajouter un service"
    },
    "text": {
      "duration": "Durée",
      "hint": "Veuillez sélectionner au moins un service",
      "total": "Montant total"
    }
  }
}
